import React, { useEffect, useState } from "react";
import { Button, Input, Label, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import payoutService from "../../../redux/services/payout.service";
toast.configure();

const PayoutCommentModal = ({ isModalOpen, toggleModal, selectedPayout, onUpdated }) => {
  const [loading, setLoading] = useState(false);
  const [payoutComment, setPayoutComment] = useState("");

  useEffect(() => {
    setPayoutComment(selectedPayout?.payoutComment || "");
  }, [selectedPayout]);

  const handleUpdatePayoutComment = async () => {
    try {
      setLoading(true);
      const response = await payoutService.updatePayoutComment(selectedPayout.id, {
        payoutComment,
      });
      if (response.data.status) {
        toast.success(response.data.message);
        onUpdated?.();
      } else {
        toast.error(response.data.message);
      }

      setTimeout(() => {
        toggleModal();
      }, 500);

    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "Unable to update payout comment");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>Payout Comment</ModalHeader>
      <ModalBody>
        <Label>Comment</Label>
        <Input
          type="textarea"
          name="payoutComment"
          id="payoutComment"
          rows={4}
          value={payoutComment}
          onChange={(e) => setPayoutComment(e.target.value)}
          placeholder="Add a comment for this payout..."
        />
      </ModalBody>
      <ModalFooter>
        <Button color="link" onClick={toggleModal}>
          Cancel
        </Button>
        <Button color="primary" disabled={loading} onClick={handleUpdatePayoutComment}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PayoutCommentModal;
